import jwt from 'jsonwebtoken';

export function getUser() {
    if (localStorage.getItem('jwt_access_token')) {
        const isTokenValid = jwt.decode(
            localStorage.getItem('jwt_access_token'),
        );

        if (isTokenValid !== null) {
            return isTokenValid;
        } else {
            return {};
        }
    } else {
        return {};
    }
}
